import React, { useEffect, useState } from 'react';
import { Card, Typography, Spin, message } from 'antd';
import StandardTable from '../../../components/common/StandardTable';
import { fetchSqlData } from '../../../services/api';

const { Title } = Typography;

interface ConstPipingTableDetailsProps {
  tableName: string;
  onBack: () => void;
}

const ConstPipingTableDetails: React.FC<ConstPipingTableDetailsProps> = ({ tableName, onBack }) => {
  const [columns, setColumns] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  // Removed client-side paging in favor of a single fetch

  useEffect(() => {
    if (!tableName) return;
    const fetchColumnsAndData = async () => {
      setLoading(true);
      try {
        // Step 1: Fetch column names
        const colQuery = `SELECT COLUMN_NAME FROM INFORMATION_SCHEMA.COLUMNS WHERE TABLE_SCHEMA = 'dbo' AND TABLE_NAME = '${tableName}' ORDER BY ORDINAL_POSITION;`;
        const colResult = await fetchSqlData('INFORMATION_SCHEMA.COLUMNS', 'TABLE_NAME', tableName, 'DiAPCQS');
        let columnNames: string[] = [];
        if (Array.isArray(colResult)) {
          if (colResult[0] && colResult[0].COLUMN_NAME) {
            columnNames = colResult.map((row: any) => row.COLUMN_NAME);
          } else if (colResult[0] && colResult[0].column_name) {
            columnNames = colResult.map((row: any) => row.column_name);
          }
          console.log(columnNames)
        }
        if (columnNames.length === 0) throw new Error('No columns found');

        // Step 2: Construct columns for StandardTable
        const tableColumns = columnNames.map((col) => ({
          title: col,
          dataIndex: col,
          key: col,
          ellipsis: false,
          width: 150,
          render: (text: any) => String(text ?? '') || '-',
          exportValue: (row: any) => (row && row[col] != null ? String(row[col]) : ''),
        }));
        setColumns(tableColumns);

        // Step 3: Fetch table data (single request, no explicit pagination)
        const tableData = await fetchSqlData(tableName, undefined, undefined, 'DiAPCQS');
        let formattedData: any[] = [];
        if (Array.isArray(tableData)) {
          formattedData = tableData.map((row, idx) => ({ key: idx, ...row }));
        }
        setData(formattedData);
        // Background incremental loading removed
      } catch (err: any) {
        message.error('Failed to fetch table details!');
      } finally {
        setLoading(false);
      }
    };
    fetchColumnsAndData();
    return () => {};
  }, [tableName]);

  // Manual load more removed; background incremental loading remains active

  return (
    <Card>
      <Title level={4}>
        <a onClick={onBack} style={{ marginRight: 16, fontSize: 18 }}>&larr; Back</a>
        Table Details: {tableName}
      </Title>
      {loading ? (
        <Spin />
      ) : (
        <StandardTable
          dataSource={data}
          columns={columns}
          rowKey="key"
          bordered
          scroll={{ x: columns.reduce((sum, col) => sum + (col.width || 150), 0) }}
          // Footer action removed since background loading is automatic
        />
      )}
    </Card>
  );
};

export default ConstPipingTableDetails;
